import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Table } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntities } from './met-donor-contact-function.reducer';
import { IMetDonorContactFunction } from 'app/shared/model/met-donor-contact-function.model';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const MetDonorContactFunction = (props: RouteComponentProps<{ url: string }>) => {
  const dispatch = useAppDispatch();

  const metDonorContactFunctionList = useAppSelector(state => state.metDonorContactFunction.entities);
  const loading = useAppSelector(state => state.metDonorContactFunction.loading);

  useEffect(() => {
    dispatch(getEntities({}));
  }, []);

  const handleSyncList = () => {
    dispatch(getEntities({}));
  };

  const { match } = props;

  return (
    <div>
      <h2 id="met-donor-contact-function-heading" data-cy="MetDonorContactFunctionHeading">
        <Translate contentKey="almobadaraMasterDataApp.metDonorContactFunction.home.title">Met Donor Contact Functions</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="almobadaraMasterDataApp.metDonorContactFunction.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to={`${match.url}/new`} className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="almobadaraMasterDataApp.metDonorContactFunction.home.createLabel">
              Create new Met Donor Contact Function
            </Translate>
          </Link>
        </div>
      </h2>
      <div className="table-responsive">
        {metDonorContactFunctionList && metDonorContactFunctionList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.metDonorContactFunction.id">ID</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.metDonorContactFunction.code">Code</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.metDonorContactFunction.name">Name</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.metDonorContactFunction.nameAr">Name Ar</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.metDonorContactFunction.nameEn">Name En</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.metDonorContactFunction.status">Status</Translate>
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {metDonorContactFunctionList.map((metDonorContactFunction, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`${match.url}/${metDonorContactFunction.id}`} color="link" size="sm">
                      {metDonorContactFunction.id}
                    </Button>
                  </td>
                  <td>{metDonorContactFunction.code}</td>
                  <td>{metDonorContactFunction.name}</td>
                  <td>{metDonorContactFunction.nameAr}</td>
                  <td>{metDonorContactFunction.nameEn}</td>
                  <td>
                    <Translate contentKey={`almobadaraMasterDataApp.Status.${metDonorContactFunction.status}`} />
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`${match.url}/${metDonorContactFunction.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`${match.url}/${metDonorContactFunction.id}/edit`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`${match.url}/${metDonorContactFunction.id}/delete`}
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Archive</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="almobadaraMasterDataApp.metDonorContactFunction.home.notFound">
                No Met Donor Contact Functions found
              </Translate>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default MetDonorContactFunction;
